<div class="wrapper-preferences">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Preferences" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  <!-- new menu layout -->
  <div class="section-main row">
    <!-- Modern Sleek Menu Widget (Icon-free) -->
    <div class="section-menu pref-menu-widget col-12 col-md-5 col-lg-3 col-xl-2">
      <ul class="pref-nav-list">

        <!-- 1. GENERAL -->
        <li class="pref-nav-group">
          <div (click)="toggleOpen('general')" class="pref-nav-item" [class.active]="
              selectedTab == 'Profile' ||
              selectedTab == 'Regional Settings' ||
              selectedTab == 'Email Language'
            ">
            <span class="nav-title">{{ "General" | translate }}</span>
            <i class="fi fi-rr-angle-small-right menu-chevron" [class.rotated]="!collapseStates.general"></i>
          </div>

          <div [(ngbCollapse)]="collapseStates.general">
            <div class="pref-subnav-container">
              <div class="pref-subnav-item" (click)="selectTab('Profile')" [class.active]="selectedTab == 'Profile'">
                <span class="subnav-title">{{ "Profile" | translate }}</span>
              </div>
              <div class="pref-subnav-item" (click)="selectTab('Regional Settings')"
                [class.active]="selectedTab == 'Regional Settings'">
                <span class="subnav-title">{{ "Regional Settings" | translate }}</span>
              </div>
              <div class="pref-subnav-item" (click)="selectTab('Email Language')"
                [class.active]="selectedTab == 'Email Language'">
                <span class="subnav-title">{{ "Email Language" | translate }}</span>
              </div>
            </div>
          </div>
        </li>

        <!-- 2. SELLING -->
        <li class="pref-nav-group">
          <div (click)="toggleOpen('selling')" class="pref-nav-item" [class.active]="
              selectedTab == 'Checkout Steps' ||
              selectedTab == 'Payments'
            ">
            <span class="nav-title">{{ "Selling" | translate }}</span>
            <i class="fi fi-rr-angle-small-right menu-chevron" [class.rotated]="!collapseStates.selling"></i>
          </div>

          <div [(ngbCollapse)]="collapseStates.selling">
            <div class="pref-subnav-container">
              <div class="pref-subnav-item" (click)="selectTab('Checkout Steps')"
                [class.active]="selectedTab == 'Checkout Steps'">
                <span class="subnav-title">{{ "Checkout" | translate }}</span>
              </div>
              <div class="pref-subnav-item" (click)="selectTab('Payments')" [class.active]="selectedTab == 'Payments'">
                <span class="subnav-title">{{ "Payments" | translate }}</span>
              </div>
            </div>
          </div>
        </li>

        <!-- 3. DOMAINS (Direct Link) -->
        <li class="pref-nav-group">
          <div class="pref-nav-item" (click)="selectTab('Domains'); toggleOffAll()"
            [class.active]="selectedTab == 'Domains'">
            <span class="nav-title" id="domain-setup">{{ "Domains" | translate }}</span>
          </div>
        </li>

        <!-- 4. TRACKING & ANALYTICS (Direct Link) -->
        <li class="pref-nav-group">
          <div class="pref-nav-item" (click)="selectTab('Tracking & Analytics'); toggleOffAll()"
            [class.active]="selectedTab == 'Tracking & Analytics'">
            <span class="nav-title">{{ "Tracking & Analytics" | translate }}</span>
          </div>
        </li>

        <!-- 5. META & BRANDING -->
        <li class="pref-nav-group">
          <div (click)="toggleOpen('metaBranding')" class="pref-nav-item" [class.active]="
              selectedTab == 'Global SEO' ||
              selectedTab == 'Site Identity' ||
              selectedTab == 'Header & Footer Scripts' ||
              selectedTab == 'Sitemap'
            ">
            <span class="nav-title">{{ "Meta & Branding" | translate }}</span>
            <i class="fi fi-rr-angle-small-right menu-chevron" [class.rotated]="!collapseStates.metaBranding"></i>
          </div>

          <div [(ngbCollapse)]="collapseStates.metaBranding">
            <div class="pref-subnav-container">
              <div class="pref-subnav-item" (click)="selectTab('Global SEO')"
                [class.active]="selectedTab == 'Global SEO'">
                <span class="subnav-title">{{ "Global SEO" | translate }}</span>
              </div>
              <div class="pref-subnav-item" (click)="selectTab('Site Identity')"
                [class.active]="selectedTab == 'Site Identity'">
                <span class="subnav-title">{{ "Site Identity" | translate }}</span>
              </div>
              <div class="pref-subnav-item" (click)="selectTab('Header & Footer Scripts')"
                [class.active]="selectedTab == 'Header & Footer Scripts'">
                <span class="subnav-title">{{ "Header/Footer Scripts" | translate }}</span>
              </div>
              <div class="pref-subnav-item" (click)="selectTab('Sitemap')" [class.active]="selectedTab == 'Sitemap'">
                <span class="subnav-title">{{ "Sitemap" | translate }}</span>
              </div>
            </div>
          </div>
        </li>

        <!-- 6. CUSTOMER EXPERIENCE -->
        <li class="pref-nav-group">
          <div (click)="toggleOpen('customerExperience')" class="pref-nav-item" [class.active]="
              selectedTab == 'Social media accounts' ||
              selectedTab == 'Hicomm' ||
              selectedTab == 'Customer Experience'
            ">
            <span class="nav-title">{{ "Customer Experience" | translate }}</span>
            <i class="fi fi-rr-angle-small-right menu-chevron" [class.rotated]="!collapseStates.customerExperience"></i>
          </div>

          <div [(ngbCollapse)]="collapseStates.customerExperience">
            <div class="pref-subnav-container">
              <div class="pref-subnav-item" (click)="selectTab('Social media accounts')"
                [class.active]="selectedTab == 'Social media accounts'">
                <span class="subnav-title">{{ "Social Media" | translate }}</span>
              </div>
              <div class="pref-subnav-item" (click)="selectTab('Hicomm')" [class.active]="selectedTab == 'Hicomm'">
                <span class="subnav-title">{{ "Hicomm" | translate }}</span>
              </div>
              <div class="pref-subnav-item" (click)="selectTab('Customer Experience')"
                [class.active]="selectedTab == 'Customer Experience'">
                <span class="subnav-title">{{ "Contact Platforms" | translate }}</span>
              </div>
            </div>
          </div>
        </li>



      </ul>
    </div>
    <!-- menu end -->

    <!-- menu card -->
    <div class="section-card col" style="min-width: 0;">
      <!-- profile -->
      <div *ngIf="selectedTab == 'Profile'" class="row">
        <div class="col-12 mt-25">
          <app-profile-preference></app-profile-preference>
        </div>
      </div>

      <!-- general -->
      <div *ngIf="selectedTab == 'Regional Settings'" class="row">
        <div class="col-12 mt-25">
          <div class="card regional-card">
            <div class="rs-tabs" role="tablist" [attr.aria-label]="'Regional Settings' | translate">
              <button type="button" role="tab" class="rs-tab" [class.active]="regionalActiveTab === 'languages'"
                [attr.aria-selected]="regionalActiveTab === 'languages'" (click)="regionalActiveTab = 'languages'">
                <i class="fi fi-rr-globe"></i>
                <span>{{ "Store Languages" | translate }}</span>
              </button>
              <button type="button" role="tab" class="rs-tab" [class.active]="regionalActiveTab === 'countries'"
                [attr.aria-selected]="regionalActiveTab === 'countries'" (click)="regionalActiveTab = 'countries'">
                <i class="fi fi-rr-flag"></i>
                <span>{{ "Store Countries" | translate }}</span>
              </button>
            </div>

            <!-- Tab Content: Languages -->
            <div *ngIf="regionalActiveTab === 'languages'" role="tabpanel">
              <div class="rs-intro">{{ "Choose the languages customers can shop in." | translate }}</div>

              <div class="rs-setting">
                <label class="rs-setting-label" for="showLanguageSelector">{{
                  "Display language selector dropdown on store." | translate
                  }}</label>
                <div class="section-switch">
                  <label class="switch mb-0">
                    <input type="checkbox" id="showLanguageSelector" [checked]="showLanguageSelector == 1"
                      (click)="toggleConfig(1, showLanguageSelector == 1)" />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>

              <div class="rs-list" role="table" [attr.aria-label]="'Store Languages' | translate">
                <div class="rs-row rs-head" role="row">
                  <span role="columnheader">{{ "Language" | translate }}</span>
                  <span role="columnheader" class="rs-col-default">{{ "Default" | translate }}</span>
                  <span role="columnheader" class="rs-col-status">{{ "Status" | translate }}</span>
                </div>
                <div class="rs-row" role="row" *ngFor="let l of language" [class.is-off]="l.status !== '1'">
                  <div class="rs-name" role="cell">
                    <div class="rs-name-line">
                      <span class="rs-name-text">{{ l.language_name }}</span>
                      <span class="rs-code">{{ l.language_code }}</span>
                      <span class="rs-badge" *ngIf="l.default == '1'">{{ "Default" | translate }}</span>
                    </div>
                    <div class="rs-meta">{{ "Updated {0}" | translate : [(l.updated_at | date : "mediumDate")] }}</div>
                  </div>
                  <div class="rs-col-default" role="cell">
                    <label class="rs-radio" [class.inputDisabled]="inputDisabled[l.language_code]">
                      <input type="radio" name="default-language" id="check{{ l.dealer_language_id }}"
                        [checked]="l.default == '1'" [disabled]="l.status !== '1'" (click)="selectOnlyOne($event)"
                        [attr.aria-label]="('Default' | translate) + ': ' + l.language_name" />
                      <span class="rs-radio-mark"></span>
                    </label>
                  </div>
                  <div class="rs-col-status" role="cell">
                    <div class="section-switch d-inline-block">
                      <label class="switch mb-0">
                        <input type="checkbox" id="toggle{{ l.dealer_language_id }}" [checked]="l.status == '1'"
                          [disabled]="l.default == '1'" (click)="toggleLangStatus($event)"
                          [attr.aria-label]="('Status' | translate) + ': ' + l.language_name" />
                        <span [ngClass]="{
                            slider: true,
                            round: true,
                            inputDisabled: slideDisabled[l.language_code]
                          }"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tab Content: Countries -->
            <div *ngIf="regionalActiveTab === 'countries'" role="tabpanel">
              <div class="rs-intro">{{ "Choose the countries customers can order from." | translate }}</div>

              <div class="rs-setting">
                <label class="rs-setting-label" for="showCountrySelector">{{
                  "Display country selector dropdown on store." | translate
                  }}</label>
                <div class="section-switch">
                  <label class="switch mb-0">
                    <input type="checkbox" id="showCountrySelector" [checked]="showCountrySelector == 1"
                      (click)="toggleConfig(2, showCountrySelector == 1)" />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>

              <div class="rs-list" role="table" [attr.aria-label]="'Store Countries' | translate">
                <div class="rs-row rs-head" role="row">
                  <span role="columnheader">{{ "Country" | translate }}</span>
                  <span role="columnheader" class="rs-col-default">{{ "Default" | translate }}</span>
                  <span role="columnheader" class="rs-col-status">{{ "Status" | translate }}</span>
                </div>
                <div class="rs-row" role="row" *ngFor="let l of countryList" [class.is-off]="l.status !== '1'">
                  <div class="rs-name" role="cell">
                    <div class="rs-name-line">
                      <span class="rs-name-text">{{ l.country_name }}</span>
                      <span class="rs-code">{{ l.country_code }}</span>
                      <i *ngIf="l.country_code == 'MYZZ'" placement="top"
                        ngbTooltip="Enabling this option, the store will display all other active countries."
                        tooltipClass="tooltipdisplay" class="fi fi-rr-comment-info rs-info"></i>
                      <span class="rs-badge" *ngIf="l.default == '1'">{{ "Default" | translate }}</span>
                    </div>
                    <div class="rs-meta">{{ "Updated {0}" | translate : [(l.updated_at | date : "mediumDate")] }}</div>
                  </div>
                  <div class="rs-col-default" role="cell">
                    <label class="rs-radio" [class.inputDisabled]="inputDisabled[l.country_code]">
                      <input type="radio" name="default-country" id="checkCountry{{ l.dealer_country_id }}"
                        [checked]="l.default == '1'" [disabled]="l.status !== '1'" (click)="selectDefaultCountry($event)"
                        [attr.aria-label]="('Default' | translate) + ': ' + l.country_name" />
                      <span class="rs-radio-mark"></span>
                    </label>
                  </div>
                  <div class="rs-col-status" role="cell">
                    <div class="section-switch d-inline-block">
                      <label class="switch mb-0">
                        <input type="checkbox" id="toggleCountry{{ l.dealer_country_id }}" [checked]="l.status == '1'"
                          [disabled]="l.default == '1'" (click)="toggleCountryStatus($event)"
                          [attr.aria-label]="('Status' | translate) + ': ' + l.country_name" />
                        <span [ngClass]="{
                            slider: true,
                            round: true,
                            inputDisabled: slideDisabled[l.country_code]
                          }"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="selectedTab == 'Email Language'">
        <div class="card mt-25 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-3"
          [ngClass]="{ 'is-loading': emailLanguageIsSaving }">
          <div class="loader" *ngIf="emailLanguageIsSaving">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <h4 class="title">{{ "Email Language (System)" | translate }}</h4>
          <p class="subtitle">
            {{
            "The email you received will be in the specified language."
            | translate
            }}
          </p>
          <p class="subtitle mt-3">
            {{ "Email Language" | translate }}:
            <select class="language-selector" [ngModel]="emailLanguageCode" (change)="emailLanguageCodeChanged($event)">
              <option *ngFor="let language of emailLanguages | keyvalue" [value]="language.key">
                {{ language.value }}
              </option>
            </select>
          </p>
          <p>
            <button class="btn btn-primary" (click)="saveEmailLanguage($event)">
              {{ "Save" | translate }}
            </button>
          </p>
        </div>
      </div>
      <!-- domains -->
      <div *ngIf="selectedTab == 'Domains'">
        <app-domain-setup></app-domain-setup>
      </div>

      <!-- general -->

      <!-- payments -->
      <div *ngIf="selectedTab == 'Payments'" class="row">
        <!-- Country selector: every setting below (Enabled switch, Auto Approve,
             couriers) follows this country. Only countries switched on in
             Regional Settings are offered. -->
        <!-- Rows are spaced by the cards' mt-25 alone; no extra column margin,
             which used to stack on top of it and open a 55px gap. -->
        <div *ngIf="paymentCountryList.length > 0" class="col-12">
          <div class="card mt-25 payment-country-card">
            <div class="payment-country-text">
              <h4 class="title">{{ "Country" | translate }}</h4>
              <p class="subtitle">
                {{ "Every setting below applies to the selected country. Only countries enabled in Regional Settings
                are listed." | translate }}
              </p>
            </div>
            <label class="payment-country-select" for="paymentCountrySelect">
              <span class="payment-country-flag" aria-hidden="true">
                <img *ngIf="!pixelFlagFailed[paymentCountryCode]" [src]="getFlagImageURL(paymentCountryCode)"
                  (error)="onPixelFlagError(paymentCountryCode)" alt="" />
                <i *ngIf="pixelFlagFailed[paymentCountryCode]" class="fi fi-rr-globe"></i>
              </span>
              <select id="paymentCountrySelect" class="payment-country-dropdown" [ngModel]="paymentCountryCode"
                (ngModelChange)="onPaymentCountryChange($event)" [attr.aria-label]="'Country' | translate">
                <option *ngFor="let c of paymentCountryList" [value]="c.country_code">
                  {{ paymentCountryLabel(c) }}
                </option>
              </select>
            </label>
          </div>
        </div>

        <div *ngFor="let data of paymentMethod" class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="card mt-25">
            <h4 class="title">{{ data.name | translate }}</h4>
            <p class="subtitle">
              {{ data.description | translate }}
            </p>
            <div class="row mt-2" *ngIf="data.type === 'cod' || data.type === 'self_collect'">
              <div class="col-12 col-sm-12 col-md-12 col-lg-7">
                <div class="align-middle">
                  <label [class.disabled]="checkPaymentMethod(data.type)">
                    <input class="custom-checkbox" type="checkbox" [disabled]="!getDealerPaymentMethod(data.type)"
                      [checked]="getAutoApproveStatus(data.type)" (click)="
                        toggleConfig(data.type, getAutoApproveStatus(data.type))
                      " />
                    {{ "Auto Approve" | translate }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12 col-sm-12 col-md-12 col-lg-7">
                <div class="align-middle section-switch">
                  <label class="switch" [class.disabled]="checkPaymentMethod(data.type)">
                    <input type="checkbox" [disabled]="checkPaymentMethod(data.type)"
                      [checked]="getDealerPaymentMethod(data.type)" (click)="
                        togglePayment(
                          data.type,
                          getDealerPaymentMethod(data.type)
                        )
                      " />
                    <span class="slider round"></span>
                  </label>
                  <span class="switch-indicator ml-2">
                    {{ (getDealerPaymentMethod(data.type) ? 'Enabled' : 'Disabled') | translate }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Courier selection — shown for all payment types except self_collect -->
            <ng-container *ngIf="data.type !== 'self_collect' && getDealerPaymentMethod(data.type)">
              <ng-container *ngIf="getCourierOptions(data) as couriers">
                <div *ngIf="couriers.length > 0" class="courier-section">
                  <hr class="courier-divider" />
                  <div class="courier-section-header courier-section-header--clickable"
                    (click)="courierSectionExpandedMap[data.type] = !courierSectionExpandedMap[data.type]">
                    <div class="d-flex align-items-center">
                      <i class="fi fi-rr-truck-moving courier-section-icon mr-2"></i>
                      <div>
                        <h5 class="courier-section-title mb-0">
                          {{ "Preferred Couriers" | translate }}
                          <span *ngIf="data.type === 'installment'" class="courier-synced-badge">
                            <i class="fi fi-rr-link-alt mr-1"></i>{{ "Synced" | translate }}
                          </span>
                        </h5>
                        <p class="courier-section-subtitle mb-0">
                          <ng-container *ngIf="data.type === 'installment'">
                            {{ getEnabledCourierCount(couriers) }} {{ "couriers enabled" | translate }}
                          </ng-container>
                          <ng-container *ngIf="data.type !== 'installment'">
                            {{ getEnabledCourierCount(couriers) }}/{{ couriers.length }} {{ "couriers enabled" |
                            translate }}
                          </ng-container>
                        </p>
                      </div>
                    </div>
                    <i class="courier-section-chevron fi"
                      [class.fi-rr-angle-down]="!courierSectionExpandedMap[data.type]"
                      [class.fi-rr-angle-up]="courierSectionExpandedMap[data.type]"></i>
                  </div>

                  <div *ngIf="courierSectionExpandedMap[data.type]" class="courier-body">
                    <!-- Synced notice for installment -->
                    <div *ngIf="data.type === 'installment'" class="courier-synced-notice">
                      <i class="fi fi-rr-info mr-2"></i>
                      {{ "Courier availability is synced with Online Banking / Credit Card / E-Wallet. Manage couriers
                      from that payment method." | translate }}
                    </div>

                    <p *ngIf="data.type !== 'installment'" class="courier-description">
                      {{ "Choose which couriers are available for this payment method. Disabled couriers will not appear
                      at checkout." | translate }}
                    </p>

                    <!-- Select All row — interactive only for non-installment -->
                    <div *ngIf="data.type !== 'installment'" class="courier-select-all-row">
                      <label class="courier-checkbox-label">
                        <span class="courier-checkbox-box"
                          [class.courier-checkbox-box--checked]="isAllCouriersEnabled(couriers)">
                          <i *ngIf="isAllCouriersEnabled(couriers)" class="fi fi-rr-check courier-checkbox-tick"></i>
                          <i *ngIf="!isAllCouriersEnabled(couriers) && getEnabledCourierCount(couriers) > 0"
                            class="fi fi-rr-minus courier-checkbox-tick"></i>
                        </span>
                        <input type="checkbox" [checked]="isAllCouriersEnabled(couriers)"
                          (change)="toggleAllCouriers($event.target['checked'], couriers, data.type)" class="d-none" />
                        <span class="courier-checkbox-text courier-checkbox-text--bold">{{ "Select All" | translate
                          }}</span>
                      </label>
                    </div>

                    <!-- Courier list -->
                    <div class="courier-list" [class.courier-list--readonly]="data.type === 'installment'">

                      <!-- Interactive rows for non-installment types -->
                      <ng-container *ngIf="data.type !== 'installment'">

                        <!-- non-cod: draggable list with reorder handle -->
                        <ng-container *ngIf="data.type === 'non_cod'">
                          <div cdkDropList (cdkDropListDropped)="dropCourier($event, data)">
                            <label *ngFor="let courier of couriers" cdkDrag class="courier-item" [class.courier-item--checked]="courier.enabled" (click)="toggleCourier(courier, data.type)">
                              <div class="courier-item-info">
                                <span cdkDragHandle class="courier-drag-handle" (click)="$event.stopPropagation()">
                                  <i class="fi fi-rr-menu-dots-vertical"></i>
                                </span>
                                <span class="courier-checkbox-box" [class.courier-checkbox-box--checked]="courier.enabled">
                                  <i *ngIf="courier.enabled" class="fi fi-rr-check courier-checkbox-tick"></i>
                                </span>
                                <div class="courier-icon-wrap">
                                  <img *ngIf="courier.icons" [src]="courier.icons" [alt]="courier.courier_name" class="courier-icon-img" onError="this.style.display='none'; this.nextElementSibling.style.display='flex'" />
                                  <i class="fi fi-rr-box-alt" [style.display]="courier.icons ? 'none' : 'flex'"></i>
                                </div>
                                <span class="courier-name">{{ courier.courier_name }}</span>
                              </div>
                              <ng-template cdkDragPreview>
                                <div style="display:flex;align-items:center;gap:8px;background:#1e2432;border:1px solid #2152ff;border-radius:8px;padding:8px 14px;color:#fff;font-size:14px;font-weight:500;box-shadow:0 4px 12px rgba(0,0,0,0.35);">
                                  <i class="fi fi-rr-menu-dots-vertical" style="color:#9aa3af;font-size:13px;"></i>
                                  <span>{{ courier.courier_name }}</span>
                                </div>
                              </ng-template>
                            </label>
                          </div>
                        </ng-container>

                        <!-- Other non-installment types (cod, etc.): no drag -->
                        <ng-container *ngIf="data.type !== 'non_cod'">
                          <label *ngFor="let courier of couriers" class="courier-item"
                            [class.courier-item--checked]="courier.enabled" (click)="toggleCourier(courier, data.type)">
                            <div class="courier-item-info">
                              <span class="courier-checkbox-box" [class.courier-checkbox-box--checked]="courier.enabled">
                                <i *ngIf="courier.enabled" class="fi fi-rr-check courier-checkbox-tick"></i>
                              </span>
                              <div class="courier-icon-wrap">
                                <img *ngIf="courier.icons" [src]="courier.icons" [alt]="courier.courier_name"
                                  class="courier-icon-img"
                                  onError="this.style.display='none'; this.nextElementSibling.style.display='flex'" />
                                <i class="fi fi-rr-box-alt" [style.display]="courier.icons ? 'none' : 'flex'"></i>
                              </div>
                              <span class="courier-name">{{ courier.courier_name }}</span>
                            </div>
                          </label>
                        </ng-container>

                      </ng-container>

                      <!-- Read-only rows for installment — only show enabled couriers, no checkbox -->
                      <ng-container *ngIf="data.type === 'installment'">
                        <div *ngFor="let courier of couriers"
                          class="courier-item courier-item--readonly courier-item--display" [hidden]="!courier.enabled">
                          <div class="courier-item-info">
                            <div class="courier-icon-wrap">
                              <img *ngIf="courier.icons" [src]="courier.icons" [alt]="courier.courier_name"
                                class="courier-icon-img"
                                onError="this.style.display='none'; this.nextElementSibling.style.display='flex'" />
                              <i class="fi fi-rr-box-alt" [style.display]="courier.icons ? 'none' : 'flex'"></i>
                            </div>
                            <span class="courier-name">{{ courier.courier_name }}</span>
                          </div>
                        </div>
                      </ng-container>

                    </div>

                    <!-- Save button — hidden for installment (managed via non_cod) -->
                    <div *ngIf="data.type !== 'installment'" class="courier-save-row">
                      <button class="btn btn-primary btn-sm"
                        [disabled]="!courierChangedMap[data.type] || courierIsSavingMap[data.type]"
                        (click)="saveCourierPreferences(data.type, couriers)">
                        <span *ngIf="courierIsSavingMap[data.type]">
                          <i class="fa fa-spinner fa-spin mr-1"></i>
                        </span>
                        {{ "Save" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <!-- end courier selection -->

          </div>
        </div>
      </div>
      <!-- payments -->

      <!-- tracking & analytics -->
      <div *ngIf="selectedTab == 'Tracking & Analytics'" class="tracking-analytics-section">
        <form [formGroup]="analyticsForm" method="post">
          <div class="card tracking-panel">

            <div class="tracking-panel-header">
              <h4 class="tracking-panel-title">{{ "Tracking & Analytics" | translate }}</h4>
              <p class="tracking-panel-subtext">
                {{ "Connect measurement tools to track how visitors find and use your storefronts." | translate }}
              </p>
            </div>

            <!-- Google Analytics -->
            <div class="tracking-row" [class.is-editing]="edit1">
              <div class="tracking-row-identity">
                <div class="tracking-icon-wrap bg-amber-50 dark:bg-amber-950/40">
                  <img src="../.././../assets/google_analytics.png" alt="Google Analytics" class="tracking-brand-img" />
                </div>
                <div>
                  <h5 class="tracking-row-title">{{ "Google Analytics" | translate }}</h5>
                  <span class="tracking-status-pill" [class.connected]="google_analytics_id">
                    <span class="status-dot"></span>
                    {{ (google_analytics_id ? "Connected" : "Not Configured") | translate }}
                  </span>
                  <p class="tracking-row-desc">
                    {{ "Measures storefront traffic and visitor behavior." | translate }}
                  </p>
                </div>
              </div>

              <div class="tracking-row-control">
                <label class="tracking-field-label">{{ "Google Analytics ID" | translate }}</label>
                <input type="text" class="form-control tracking-input" placeholder="UA-XXXXX-Y or G-XXXXXXXXXX"
                  formControlName="google_analytics_id" value="{{ google_analytics_id }}" [readonly]="!edit1" />
                <div class="tracking-row-actions">
                  <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center" *ngIf="!edit1"
                    (click)="editForm(1)">
                    <i class="fi fi-rr-edit mr-1"></i>
                    <span>{{ "Manage Analytics" | translate }}</span>
                  </button>
                  <ng-container *ngIf="edit1">
                    <button type="button" class="btn btn-light btn-sm" (click)="editForm(1, false)">
                      {{ "Cancel" | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center"
                      (click)="analyticsDataUpdate('google', 1)">
                      <i class="fi fi-rr-check mr-1"></i>
                      <span>{{ "Save" | translate }}</span>
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>

            <!-- Facebook Pixel -->
            <div class="tracking-row">
              <div class="tracking-row-identity">
                <div class="tracking-icon-wrap bg-blue-50 dark:bg-blue-950/40">
                  <img src="../.././../assets/facebook_pixel.png" alt="Facebook Pixel" class="tracking-brand-img" />
                </div>
                <div>
                  <h5 class="tracking-row-title">{{ "Facebook Pixel" | translate }}</h5>
                  <span class="tracking-status-pill" [class.connected]="facebookPixels.length">
                    <span class="status-dot"></span>
                    {{ (facebookPixels.length ? "Connected" : "Not Configured") | translate }}
                  </span>
                  <p class="tracking-row-desc">
                    {{ "Tracks conversions from your Meta ads. Global pixels load on every storefront; country pixels
                    load only on that country's storefront." | translate }}
                  </p>
                </div>
              </div>

              <div class="tracking-row-control">
                <label class="tracking-field-label">{{ "Facebook Pixel IDs" | translate }}</label>
                <div *ngIf="!facebookPixels.length" class="pixel-empty-note">
                  {{ "No pixel configured" | translate }}
                </div>
                <div class="pixel-summary-list" *ngIf="facebookPixels.length">
                  <div class="pixel-summary-row" *ngFor="let pixel of facebookPixels; let i = index">
                    <code class="pixel-id">{{ pixel.pixel_id }}</code>
                    <span class="capi-badge" *ngIf="pixel.capi && pixel.capi !== 'none'"
                      [title]="'Purchases are also sent from our server for this pixel.' | translate">
                      <i class="fi fi-rr-cloud-upload mr-1"></i>
                      {{ "CAPI" | translate }}
                    </span>
                    <span class="pixel-country-badges">
                      <ng-container *ngFor="let code of pixel.countries" [ngTemplateOutlet]="pixelCountryBadge"
                        [ngTemplateOutletContext]="{ $implicit: code }"></ng-container>
                    </span>
                    <span class="pixel-row-actions">
                      <button type="button" class="btn btn-link p-0 pixel-action-btn"
                        [attr.aria-label]="'Edit' | translate" [title]="'Edit' | translate"
                        (click)="openPixelDialog(pixelDialog, i)">
                        <i class="fi fi-rr-edit"></i>
                      </button>
                      <button type="button" class="btn btn-link p-0 pixel-action-btn text-danger"
                        [attr.aria-label]="'Remove' | translate" [title]="'Remove' | translate"
                        (click)="removePixel(i)">
                        <i class="fi fi-rr-trash"></i>
                      </button>
                    </span>
                  </div>
                </div>
                <div class="tracking-row-actions">
                  <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center"
                    [disabled]="facebookPixels.length >= maxFacebookPixels" (click)="openPixelDialog(pixelDialog)">
                    <i class="fi fi-rr-plus mr-1"></i>
                    <span>{{ "Connect Pixel" | translate }}</span>
                  </button>
                  <small class="tracking-row-hint" *ngIf="facebookPixels.length >= maxFacebookPixels">
                    {{ "You can add up to 10 Pixel IDs." | translate }}
                  </small>
                </div>
              </div>

              <!-- Manual Pixel Event Helper Banner & Button (Full Width) -->
              <div class="tracking-row-fullwidth">
                <app-facebook-pixel-manual-event [facebookPixels]="facebookPixels" [storeId]="store?.store_id"
                  [bearer]="bearer">
                </app-facebook-pixel-manual-event>
              </div>
            </div>

            <!-- TikTok Pixel -->
            <div class="tracking-row" [class.is-editing]="edit3">
              <div class="tracking-row-identity">
                <div class="tracking-icon-wrap bg-gray-100 dark:bg-gray-800">
                  <img src="../.././../assets/tiktok_pixel.png" alt="TikTok Pixel" class="tracking-brand-img" />
                </div>
                <div>
                  <h5 class="tracking-row-title">{{ "TikTok Pixel" | translate }}</h5>
                  <span class="tracking-status-pill" [class.connected]="tiktok_pixel_id">
                    <span class="status-dot"></span>
                    {{ (tiktok_pixel_id ? "Connected" : "Not Configured") | translate }}
                  </span>
                  <p class="tracking-row-desc">
                    {{ "Tracks conversions from your TikTok ads." | translate }}
                  </p>
                </div>
              </div>

              <div class="tracking-row-control">
                <label class="tracking-field-label">{{ "TikTok Pixel ID" | translate }}</label>
                <input type="text" class="form-control tracking-input" placeholder="C1234567890ABCDEF"
                  formControlName="tiktok_pixel_id" value="{{ tiktok_pixel_id }}" [readonly]="!edit3" />
                <div class="tracking-row-actions">
                  <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center" *ngIf="!edit3"
                    (click)="editForm(3)">
                    <i class="fi fi-rr-edit mr-1"></i>
                    <span>{{ "Manage Pixel" | translate }}</span>
                  </button>
                  <ng-container *ngIf="edit3">
                    <button type="button" class="btn btn-light btn-sm" (click)="editForm(3, false)">
                      {{ "Cancel" | translate }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center"
                      (click)="analyticsDataUpdate('tiktok', 3)">
                      <i class="fi fi-rr-check mr-1"></i>
                      <span>{{ "Save" | translate }}</span>
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>

          </div>
        </form>
      </div>
      <!-- tracking & analytics -->

      <!-- meta & branding -->
      <div *ngIf="selectedTab == 'Global SEO'" class="global-seo-section">
        <form [formGroup]="globalSEOForm" method="post">
          <div class="card seo-card" [class.is-editing]="edit4" [class.is-loading]="showloader1">

            <div class="seo-card-header">
              <div class="d-flex items-center justify-between flex-wrap gap-3">
                <div>
                  <h4 class="seo-card-title">{{ "Global SEO" | translate }}</h4>
                  <p class="seo-card-subtext">{{ "Manage global search engine metadata and site branding" | translate }}
                  </p>
                </div>

                <div class="d-flex align-items-center gap-2 flex-wrap">
                  <!-- Language Selector Dropdown -->
                  <div ngbDropdown class="d-inline-block">
                    <button class="btn btn-outline-secondary btn-sm seo-lang-btn" id="dropdownBasic2" ngbDropdownToggle>
                      <i class="fi fi-rr-globe mr-1.5 text-indigo-500"></i>
                      <span>{{ language_name }}</span>
                      <i class="fi fi-rr-angle-small-down ml-1.5 text-xs"></i>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="custom-dropdown">
                      <button ngbDropdownItem *ngFor="let l of language"
                        (click)="changeLangauge(l.language_code, l.language_name)">
                        {{ l.language_name }}
                      </button>
                    </div>
                  </div>

                  <!-- Header Action Buttons (Prominent Top Placement) -->
                  <button type="button" class="btn btn-outline-primary btn-sm d-inline-flex align-items-center"
                    *ngIf="!edit4" (click)="editForm(4)" [disabled]="showloader1 === true">
                    <i class="fi fi-rr-edit mr-1"></i>
                    <span>{{ "Edit SEO" | translate }}</span>
                  </button>

                  <div class="d-flex align-items-center gap-2" *ngIf="edit4">
                    <button type="button" class="btn btn-light btn-sm d-inline-flex align-items-center"
                      (click)="editForm(4, false)">
                      <span>{{ "Cancel" | translate }}</span>
                    </button>
                    <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center"
                      (click)="updateSeoInfo(4); editForm(4, false)" [disabled]="!edit4 || !isDisableSave">
                      <i class="fi fi-rr-check mr-1"></i>
                      <span>{{ "Save Changes" | translate }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="seo-card-body">
              <div class="row g-4">

                <!-- Site Name -->
                <div class="col-12 col-lg-6 mb-3">
                  <div class="form-group mb-0">
                    <label class="seo-field-label">{{ "Site Name" | translate }}</label>
                    <input type="text" class="form-control seo-input" value="{{ store_name }}" [readonly]="true" />
                  </div>
                </div>

                <!-- Page Title -->
                <div class="col-12 col-lg-6 mb-3">
                  <div class="form-group mb-0">
                    <label class="seo-field-label">{{ "Page Title" | translate }}</label>
                    <input type="text" class="form-control seo-input" formControlName="page_title"
                      value="{{ page_title }}" (change)="globalSEOFormChange()" [readonly]="!edit4" />
                  </div>
                </div>

                <!-- Meta Description -->
                <div class="col-12 col-lg-6 mb-3">
                  <div class="form-group mb-0">
                    <div class="d-flex align-items-center justify-content-between mb-1.5">
                      <label class="seo-field-label mb-0">{{ "Meta Description" | translate }}</label>
                      <button type="button" [disabled]="!edit4" [class.is-loading]="!edit4"
                        (click)="showAIGlobalMetaDesc({ desc: 'meta_description - for Global SEO' })"
                        class="ai-assistant-btn" [ngClass]="enableAIAssistant !== true ? 'disabled' : ''">
                        <i class="fas fa-magic mr-1 text-xs"></i>
                        <span>AI Assistant</span>
                      </button>
                    </div>
                    <textarea [readonly]="!edit4" class="form-control seo-textarea" rows="3"
                      formControlName="description" (change)="globalSEOFormChange()"></textarea>
                  </div>
                </div>

                <!-- Meta Keywords -->
                <div class="col-12 col-lg-6 mb-3">
                  <div class="form-group mb-0">
                    <div class="d-flex align-items-center justify-content-between mb-1.5">
                      <label class="seo-field-label mb-0">{{ "Meta Keyword" | translate }}</label>
                      <button type="button" [disabled]="!edit4" [class.is-loading]="!edit4"
                        (click)="showAIGlobalMetaKeyword({ desc: 'meta_keyword - for Global SEO' })"
                        class="ai-assistant-btn" [ngClass]="enableAIAssistant !== true ? 'disabled' : ''">
                        <i class="fas fa-magic mr-1 text-xs"></i>
                        <span>AI Assistant</span>
                      </button>
                    </div>
                    <input type="text" class="form-control seo-input mb-1.5" formControlName="keywords"
                      (change)="globalSEOFormChange()" [readonly]="!edit4" />
                    <span class="seo-field-hint">
                      {{ "Note: Please include meta keywords separated by commas." | translate }}
                    </span>
                  </div>
                </div>

              </div>

              <!-- Live Google Search Result Preview & Where It Reflects -->
              <div class="seo-preview-wrapper mt-4 pt-4 border-top">
                <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                  <div class="d-flex align-items-center gap-2">
                    <span class="preview-title-badge">
                      <i class="fab fa-google text-primary mr-1"></i>
                      {{ "Google Search Snippet Preview" | translate }}
                    </span>
                    <span class="preview-live-dot" title="Live real-time preview"></span>
                  </div>
                  <span class="text-xs text-muted">
                    {{ "Real-time preview of how your page appears in search results" | translate }}
                  </span>
                </div>

                <!-- Google Snippet Card -->
                <div class="google-snippet-card mb-3">
                  <div class="google-snippet-header">
                    <div class="google-favicon">
                      <i class="fas fa-globe"></i>
                    </div>
                    <div class="google-url-info">
                      <span class="google-site-name">{{ store_name || 'Your Store' }}</span>
                      <span class="google-site-url">{{ store_url || 'https://yourstore.com' }}</span>
                    </div>
                  </div>
                  <h3 class="google-title-link">
                    {{ globalSEOForm.get('page_title')?.value || page_title || store_name || 'Store Page Title' }}
                  </h3>
                  <p class="google-snippet-desc">
                    {{ globalSEOForm.get('description')?.value || description || ('Add a meta description to control how
                    your store is described in Google search results.') | translate }}
                  </p>
                </div>

                <!-- Where It Reflects Explainer Badges -->
                <div class="where-it-reflects-box">
                  <span class="where-title">{{ "Where this metadata reflects:" | translate }}</span>
                  <div class="d-flex flex-wrap gap-2 mt-2">
                    <div class="reflect-badge"
                      title="Page Title is shown in Google search result headers and browser tab titles">
                      <i class="fi fi-rr-browser text-indigo-500 mr-1.5"></i>
                      <span><strong>{{ "Page Title" | translate }}:</strong> {{ "Search Results & Browser Tabs" |
                        translate }}</span>
                    </div>
                    <div class="reflect-badge"
                      title="Meta Description is shown as snippet summary under Google links & social cards">
                      <i class="fi fi-rr-search-alt text-emerald-500 mr-1.5"></i>
                      <span><strong>{{ "Meta Description" | translate }}:</strong> {{ "Search Result Snippets & Social
                        Sharing" | translate }}</span>
                    </div>
                    <div class="reflect-badge" title="Meta Keywords guide search engine crawlers on topic relevance">
                      <i class="fi fi-rr-tags text-purple-500 mr-1.5"></i>
                      <span><strong>{{ "Meta Keywords" | translate }}:</strong> {{ "Search Engine Topic Indexing" |
                        translate }}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="seo-card-footer">
              <button type="button" class="btn btn-outline-primary btn-sm d-inline-flex align-items-center"
                *ngIf="!edit4" (click)="editForm(4)" [disabled]="showloader1 === true">
                <i class="fi fi-rr-edit mr-1"></i>
                <span>{{ "Edit SEO" | translate }}</span>
              </button>

              <div class="d-flex items-center gap-2" *ngIf="edit4">
                <button type="button" class="btn btn-light btn-sm d-inline-flex align-items-center"
                  (click)="editForm(4, false)">
                  <span>{{ "Cancel" | translate }}</span>
                </button>
                <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center"
                  (click)="updateSeoInfo(4); editForm(4, false)" [disabled]="!edit4 || !isDisableSave">
                  <i class="fi fi-rr-check mr-1"></i>
                  <span>{{ "Save Changes" | translate }}</span>
                </button>
              </div>
            </div>

            <div class="loader" *ngIf="showloader1">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </form>
      </div>

      <div *ngIf="selectedTab == 'Site Identity'" class="site-identity-section">
        <div class="card identity-card" [class.is-loading]="snippetIsLoading || storeLogoIsLoading">

          <div class="identity-card-header">
            <div>
              <h4 class="identity-card-title">{{ "Site Identity" | translate }}</h4>
              <p class="identity-card-subtext">{{ "Manage store logo, browser favicon, social preview cards, and loading
                animations" | translate }}</p>
            </div>
          </div>

          <div class="identity-card-body">
            <div class="row g-4">

              <!-- Left Column: Form Assets Cards -->
              <div class="col-12 col-lg-8">

                <!-- 1. Store Logo Card -->
                <div class="asset-card mb-4">
                  <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                    <div class="d-flex align-items-center gap-2">
                      <div class="asset-icon-badge bg-indigo-50 dark:bg-indigo-950/40 text-indigo-500">
                        <i class="fi fi-rr-picture"></i>
                      </div>
                      <div>
                        <h5 class="asset-card-title mb-0">{{ "Store Logo" | translate }}</h5>
                        <span class="asset-card-desc">{{ "Shown in your website header and footer per language" |
                          translate }}</span>
                      </div>
                    </div>

                    <!-- Language Selector Dropdown -->
                    <div ngbDropdown class="d-inline-block">
                      <button class="btn btn-outline-secondary btn-sm identity-lang-btn" id="storeLogoLanguageDropdown"
                        ngbDropdownToggle>
                        <i class="fi fi-rr-globe mr-1.5 text-indigo-500"></i>
                        <span>{{ storeLogoLanguageName }}</span>
                        <i class="fi fi-rr-angle-small-down ml-1.5 text-xs"></i>
                      </button>
                      <div ngbDropdownMenu aria-labelledby="storeLogoLanguageDropdown" class="custom-dropdown">
                        <button ngbDropdownItem *ngFor="let l of storeLogoLanguages"
                          (click)="changeStoreLogoLanguage(l.language_code, l.language_name)">
                          {{ l.language_name }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Media Selector -->
                  <div class="mb-3">
                    <media-selector [(imgURL)]="storeLogoUrl" [(mediaID)]="storeLogoMediaId"
                      (mediaChanged)="storeLogoChanged($event)"></media-selector>
                  </div>

                  <!-- Logo Dimensions & Apply to All Checkbox -->
                  <div class="row g-3 align-items-end mb-3">
                    <div class="col-6 col-sm-4">
                      <label for="store-logo-width" class="identity-field-label">{{ "Logo Width (px)" | translate
                        }}</label>
                      <input id="store-logo-width" type="number" min="1" class="form-control identity-input"
                        [(ngModel)]="storeLogoWidth" />
                    </div>
                    <div class="col-6 col-sm-4">
                      <label for="store-logo-height" class="identity-field-label">{{ "Logo Height (px)" | translate
                        }}</label>
                      <input id="store-logo-height" type="number" min="1" class="form-control identity-input"
                        [(ngModel)]="storeLogoHeight" />
                    </div>
                    <div class="col-12 col-sm-4 mt-2 mt-sm-0">
                      <label class="apply-all-pill d-flex align-items-center mb-0 cursor-pointer">
                        <input type="checkbox" class="custom-checkbox mr-2" [(ngModel)]="storeLogoApplyAllLanguages" />
                        <span class="text-xs font-medium">{{ "Apply to all languages" | translate }}</span>
                      </label>
                    </div>
                  </div>

                  <div class="d-flex justify-content-end">
                    <button class="btn btn-primary btn-sm d-inline-flex align-items-center" (click)="saveStoreLogo()"
                      [disabled]="storeLogoIsSaving || storeLogoIsLoading">
                      <span *ngIf="storeLogoIsSaving">
                        <i class="fa fa-spinner fa-spin mr-1"></i>
                      </span>
                      <i class="fi fi-rr-check mr-1" *ngIf="!storeLogoIsSaving"></i>
                      <span>{{ "Save Store Logo" | translate }}</span>
                    </button>
                  </div>
                </div>

                <!-- 2. Favicon & Open Graph (Social Link Preview) Card -->
                <div class="asset-card mb-4">
                  <div class="d-flex align-items-center gap-2 mb-3">
                    <div class="asset-icon-badge bg-emerald-50 dark:bg-emerald-950/40 text-emerald-500">
                      <i class="fi fi-rr-globe"></i>
                    </div>
                    <div>
                      <h5 class="asset-card-title mb-0">{{ "Favicon & Social Link Preview" | translate }}</h5>
                      <span class="asset-card-desc">{{ "Icons and images displayed in browser tabs and social shares" |
                        translate }}</span>
                    </div>
                  </div>

                  <div class="row g-4">
                    <!-- Favicon -->
                    <div class="col-12 col-md-6 mb-3">
                      <div class="d-flex align-items-center gap-2 mb-2 flex-wrap">
                        <label class="identity-field-label mb-0">{{ "Favicon" | translate }}</label>
                        <span class="dimension-tag">16x16 / 32x32 px</span>
                      </div>
                      <media-selector [(imgURL)]="favIcoImgURL" [(mediaID)]="favIcoPhotoId"
                        (mediaChanged)="favIcoChanged($event)"></media-selector>
                    </div>

                    <!-- Link Preview OG:Image -->
                    <div class="col-12 col-md-6 mb-3">
                      <div class="d-flex align-items-center gap-2 mb-2 flex-wrap">
                        <label class="identity-field-label mb-0">{{ "Link Preview (OG:Image)" | translate }}</label>
                        <span class="dimension-tag">1200x630 px</span>
                      </div>
                      <media-selector [(imgURL)]="ogimgURL" [(mediaID)]="ogImgPhotoId"
                        (mediaChanged)="ogImgChanged($event)"></media-selector>
                    </div>
                  </div>
                </div>

                <!-- 3. Site Loading Animation Selector Card -->
                <div class="asset-card">
                  <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                    <div class="d-flex align-items-center gap-2">
                      <div class="asset-icon-badge bg-purple-50 dark:bg-purple-950/40 text-purple-500">
                        <i class="fi fi-rr-spinner"></i>
                      </div>
                      <div>
                        <h5 class="asset-card-title mb-0">{{ "Loading Icon" | translate }}</h5>
                        <span class="asset-card-desc">{{ "Select an animated spinner for page transition states" |
                          translate }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="row g-3 mb-3">
                    <div class="col-6 col-sm-4 col-md-2.4 mb-2" *ngFor="let style of loadingIconLabel">
                      <label [for]="'loading_' + style" class="loading-card-option d-block cursor-pointer mb-0">
                        <div class="loading-card-box"
                          [class.active]="loadingIconGet === style || (style === 'default' && !loadingIconGet)">
                          <div class="loading-preview-wrap mb-2">
                            <img *ngIf="style === 'default'" src="https://cdn.estore5s.com/asset/loading/wellous.gif"
                              alt="default loading" />
                            <img *ngIf="style === 'afyaa'" src="https://cdn.estore5s.com/asset/loading/afyaa.gif"
                              alt="afyaa loading" />
                            <img *ngIf="style === 'estore1'" src="https://cdn.estore5s.com/asset/loading/estore_1.gif"
                              alt="estore1 loading" />
                            <img *ngIf="style === 'estore2'" src="https://cdn.estore5s.com/asset/loading/estore_2.gif"
                              alt="estore2 loading" />
                            <img *ngIf="style === 'estore3'" src="https://cdn.estore5s.com/asset/loading/estore_3.gif"
                              alt="estore3 loading" />
                          </div>
                          <span class="loading-card-name">{{ style | titlecase }}</span>
                          <div class="loading-radio-indicator mt-1">
                            <i class="fas fa-check-circle text-emerald-500"
                              *ngIf="loadingIconGet === style || (style === 'default' && !loadingIconGet)"></i>
                          </div>
                        </div>

                        <input type="radio" [id]="'loading_' + style" name="loading_icon_style" [value]="style"
                          [(ngModel)]="loadingIconGet" class="d-none" />
                      </label>
                    </div>
                  </div>

                  <div class="d-flex justify-content-end">
                    <button class="btn btn-primary btn-sm d-inline-flex align-items-center"
                      (click)="saveLoadingIconSettings(loadingIconGet)" [disabled]="isLoadingIconSaving">
                      <span *ngIf="isLoadingIconSaving">
                        <i class="fa fa-spinner fa-spin mr-1"></i>
                      </span>
                      <i class="fi fi-rr-check mr-1" *ngIf="!isLoadingIconSaving"></i>
                      <span>{{ "Save Loading Icon" | translate }}</span>
                    </button>
                  </div>
                </div>

              </div>

              <!-- Right Column: Helper Guidelines Box -->
              <div class="col-12 col-lg-4">
                <div class="identity-guide-box">
                  <div class="guide-header mb-3">
                    <i class="fi fi-rr-info text-indigo-500 mr-2 text-base"></i>
                    <span class="guide-title">{{ "Site Identity Guide" | translate }}</span>
                  </div>

                  <div class="guide-item mb-3">
                    <h6 class="guide-item-title"><i class="fas fa-image text-indigo-400 mr-1.5"></i> {{ "Store Logo" |
                      translate }}</h6>
                    <p class="guide-item-text">
                      {{ "Appears in your website header and footer. Upload a transparent PNG. You can set different
                      logos per language using the language picker." | translate }}
                    </p>
                  </div>

                  <div class="guide-item mb-3">
                    <h6 class="guide-item-title"><i class="fas fa-globe text-emerald-400 mr-1.5"></i> {{ "Favicon" |
                      translate }}</h6>
                    <p class="guide-item-text">
                      {{ "Appears in browser tabs and bookmark bars (typically 16x16 or 32x32 px) to help users identify
                      your website." | translate }}
                    </p>
                  </div>

                  <div class="guide-item mb-3">
                    <h6 class="guide-item-title"><i class="fas fa-share-alt text-purple-400 mr-1.5"></i> {{ "OG:Image
                      (Social Preview)" | translate }}</h6>
                    <p class="guide-item-text">
                      {{ "Displayed on Facebook, WhatsApp, LinkedIn & Twitter when sharing links. Best resolution is
                      1200x630 px." | translate }}
                    </p>
                    <span class="guide-note">{{ "Note: Social caches update within 5-10 minutes." | translate }}</span>
                  </div>

                  <div class="guide-item">
                    <h6 class="guide-item-title"><i class="fas fa-spinner text-amber-400 mr-1.5"></i> {{ "Loading
                      Spinner" | translate }}</h6>
                    <p class="guide-item-text">
                      {{ "Animated spinner displayed when pages or checkout steps refresh." | translate }}
                    </p>
                    <span class="guide-note">{{ "Note: Takes 1-3 minutes to reflect." | translate }}</span>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="loader" *ngIf="snippetIsLoading">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>

      <div *ngIf="selectedTab == 'Header & Footer Scripts'">
        <form [formGroup]="customSnippet" method="post" class="row">
          <div class="col-12">
            <div class="card" [ngClass]="{
                'is-loading': snippetIsLoading
              }">
              <h4 class="title d-flex align-items-center mb-3">
                {{ "Header/Footer Scripts" | translate }}
                <button type="button"
                  class="btn btn-link p-0 ml-2 text-decoration-none d-inline-flex align-items-center"
                  (click)="showScriptInstructions = !showScriptInstructions" title="Toggle instructions"
                  style="box-shadow: none;">
                  <i class="fa fa-question-circle text-primary" style="font-size: 16px;"></i>
                </button>
              </h4>

              <!-- Collapsible Instruction Banner -->
              <div *ngIf="showScriptInstructions"
                class="alert alert-info alert-dismissible fade show p-4 mb-4 rounded-lg position-relative border-0"
                style="background-color: #e0f2fe; color: #0369a1; box-shadow: 0 2px 4px rgba(3, 105, 161, 0.04); width: 100%;">
                <div class="d-flex pr-4">
                  <i class="fa fa-info-circle mr-3 mt-1" style="font-size: 20px; color: #0284c7;"></i>
                  <div>
                    <h5 class="font-weight-bold mb-1" style="color: #0369a1;">{{ "What's this?" | translate }}</h5>
                    <p class="mb-2 text-sm" style="color: #0c4a6e; font-size: 13px; line-height: 1.6;">
                      {{ "If you have any third-party snippets, external &lt;script&gt; tags, custom &lt;style&gt;, or
                      &lt;meta&gt; tags that you'd like to use in your storefront, you can easily insert them here.
                      Simply paste the code into the input text area and it will be embedded directly into your
                      storefront." | translate }}
                    </p>
                    <p class="mb-0 text-sm" style="color: #0c4a6e; font-size: 13px; line-height: 1.6;">
                      {{ "This feature allows you to bring in external resources or customize the look and feel of your
                      content to better suit your needs. So go ahead and add your favorite third-party snippets,
                      external scripts, or custom styles to create the perfect experience for your users!" | translate
                      }}
                    </p>
                  </div>
                </div>
                <button type="button" class="close" (click)="showScriptInstructions = false"
                  style="outline: none; opacity: 0.7; color: #0369a1; padding: 1rem 1.25rem;">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="w-full mt-3">
                <div class="row">
                  <div class="col-12 mb-4">
                    <div class="d-flex justify-content-between align-items-baseline mb-2">
                      <label for="header-script" class="title-2 mb-0">{{ "Script in header" | translate }}</label>
                      <small class="text-muted">{{ "{0} characters" | translate: [scriptLength('headerScriptValue') | number] }}</small>
                    </div>
                    <div #headerScriptRef class="script-editor-element"></div>
                    <div #headerScriptRef2 class="script-editor-element"></div>
                  </div>
                  <div class="col-12 mb-4">
                    <div class="d-flex justify-content-between align-items-baseline mb-2">
                      <label for="body-script" class="title-2 mb-0">{{ "Script in body" | translate }}</label>
                      <small class="text-muted">{{ "{0} characters" | translate: [scriptLength('bodyScriptValue') | number] }}</small>
                    </div>
                    <div #bodyScriptRef class="script-editor-element"></div>
                    <div #bodyScriptRef2 class="script-editor-element"></div>
                  </div>
                  <div class="col-12 mb-4">
                    <div class="d-flex justify-content-between align-items-baseline mb-2">
                      <label for="footer-script" class="title-2 mb-0">{{ "Script after body" | translate }}</label>
                      <small class="text-muted">{{ "{0} characters" | translate: [scriptLength('footerScriptValue') | number] }}</small>
                    </div>
                    <div #footerScriptRef class="script-editor-element"></div>
                    <div #footerScriptRef2 class="script-editor-element"></div>
                  </div>
                </div>
                <div class="d-flex justify-content-end align-items-center flex-wrap mt-2" style="gap: 12px;">
                  <!-- Combined size as saved, against the limit, so dealers see it before clicking Save -->
                  <small aria-live="polite"
                    [ngClass]="snippetIsTooLong ? 'text-danger font-weight-bold' : (snippetIsNearLimit ? 'text-warning font-weight-bold' : 'text-muted')"
                    [title]="'Includes the formatting added when your scripts are saved' | translate">
                    <i class="fa fa-exclamation-triangle mr-1" *ngIf="snippetIsTooLong || snippetIsNearLimit"></i>
                    {{ "Total: {0} / {1} characters" | translate: [snippetLength | number, snippetMaxLength | number] }}
                    <ng-container *ngIf="snippetIsTooLong">
                      &middot; {{ "Remove {0} characters to save" | translate: [(snippetLength - snippetMaxLength) | number] }}
                    </ng-container>
                  </small>
                  <button class="btn btn-primary btn-sm d-inline-flex align-items-center" (click)="saveSnippet()"
                    [disabled]="snippetIsLoading || !snippetIsChanged || snippetIsTooLong">
                    <i class="fi fi-rr-check mr-1" *ngIf="!snippetIsLoading"></i>
                    <span>{{ "Save" | translate }}</span>
                  </button>
                </div>
              </div>
              <div class="loader" *ngIf="snippetIsLoading">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div *ngIf="selectedTab == 'Sitemap'">
        <form [formGroup]="customSnippet" method="post" class="row">
          <div class="col-12">
            <div class="card" [ngClass]="{
                'is-loading': snippetIsLoading
              }">
              <h4 class="title">
                {{ "Sitemap" | translate }}
              </h4>
              <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3 w-full mt-3">
                <div class="lg:col-span-2 lg:order-1 order-2">
                  <div class="sitemap-card">
                    <div class="sitemap-details">
                      <div class="form-group">
                        <label for="sitemap-path">{{ "Sitemap Path" | translate }}:</label>
                        <input #sitemapPathRef name="sitemap-path" id="sitemap-path" class="form-control" readonly
                          value="{{ store_url }}/sitemap.xml" />
                      </div>
                    </div>
                    <div class="sitemap-actions">
                      <button class="btn btn-primary btn-sm mr-2 d-inline-flex align-items-center" id="copy-sitemap"
                        (click)="copySitemap()">
                        <i class="fi fi-rr-copy mr-1"></i>
                        <span>{{ "Copy URL" | translate }}</span>
                      </button>
                      <button class="btn btn-outline-primary btn-sm d-inline-flex align-items-center"
                        id="download-sitemap" (click)="downloadSitemap()">
                        <i class="fi fi-rr-download mr-1"></i>
                        <span>{{ "Download as XML" | translate }}</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="lg:col-span-1 lg:order-2 order-1">
                  <div class="rounded-md p-3 bg-teal-50">
                    <label class="font-medium text-teal-800">{{
                      "What's this?" | translate
                      }}</label>
                    <p class="mb-3 text-teal-700">
                      {{
                      "A sitemap is a list of a website's pages, aiding search engines in indexing and improving user
                      navigation. It's essential for website visibility and usability."
                      | translate
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="loader" *ngIf="snippetIsLoading">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- meta & branding -->

      <!-- customer experience -->
      <div *ngIf="selectedTab == 'Social media accounts'" class="row w-100">
        <form [formGroup]="socialMediaForm" method="post" class="w-100">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="card" [ngClass]="{ 'is-loading': showloader2 }">
              <h4 class="title">{{ "Social Media" | translate }}</h4>
              <p class="subtitle">
                {{
                "Specify your social media accounts to encourage customers to connect with you. These accounts will be
                displayed in email notifications sent by your store."
                | translate
                }}
              </p>

              <!-- new form -->
              <div class="mt-3 cuba-form">
                <div class="row">
                  <div class="col-12 col-lg-6 mt-2">
                    <label class="label d-flex flex-row">
                      <div class="social-icon">
                        <img src="../../../assets/icon/facebook-icon.png" alt="facebook" />
                      </div>
                      <span>
                        {{ "Facebook" | translate }}
                      </span>
                    </label>
                    <div class="form-group">
                      <input type="text" class="form-control" formControlName="facebook" value="{{ facebook }}"
                        [readonly]="!edit5" />
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 mt-2">
                    <label class="label d-flex flex-row">
                      <div class="social-icon">
                        <img src="../../../assets/icon/instagram-icon.png" alt="instagram" />
                      </div>
                      <span>
                        {{ "Instagram" | translate }}
                      </span>
                    </label>
                    <div class="form-group">
                      <input type="text" class="form-control" formControlName="instagram" value="{{ instagram }}"
                        [readonly]="!edit5" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-6 mt-2">
                    <label class="label d-flex flex-row">
                      <div class="social-icon">
                        <img src="../../../assets/icon/twitter-icon.png" alt="twitter" />
                      </div>
                      <span>
                        {{ "Twitter" | translate }}
                      </span>
                    </label>
                    <div class="form-group">
                      <input type="text" class="form-control" formControlName="twitter" value="{{ twitter }}"
                        [readonly]="!edit5" />
                    </div>
                  </div>
                  <div class="col-12 col-lg-6 mt-2">
                    <label class="label d-flex flex-row">
                      <div class="social-icon">
                        <img src="../../../assets/icon/youtube-icon.png" alt="youtube" />
                      </div>
                      <span>
                        {{ "YouTube" | translate }}
                      </span>
                    </label>
                    <div class="form-group">
                      <input type="text" class="form-control" formControlName="youtube" value="{{ youtube }}"
                        [readonly]="!edit5" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-lg-6 mt-2">
                    <label class="label d-flex flex-row">
                      <div class="social-icon">
                        <img src="../../../assets/icon/tiktok-icon.png" alt="tiktok" />
                      </div>
                      <span>
                        {{ "TikTok" | translate }}
                      </span>
                    </label>
                    <div class="form-group">
                      <input type="text" class="form-control" formControlName="tiktok" value="{{ tiktok }}"
                        [readonly]="!edit5" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- new form -->

              <!-- <div class="row mt-3">
                <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                  <h4 class="title-2 mt-2">{{ "Facebook" | translate }}</h4>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="facebook"
                      value="{{ facebook }}"
                      [readonly]="!edit4"
                    />
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                  <h4 class="title-2 mt-2">{{ "Instagram" | translate }}</h4>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="instagram"
                      value="{{ instagram }}"
                      [readonly]="!edit4"
                    />
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                  <h4 class="title-2 mt-2">{{ "Twitter" | translate }}</h4>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="twitter"
                      value="{{ twitter }}"
                      [readonly]="!edit4"
                    />
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                  <h4 class="title-2 mt-2">{{ "YouTube" | translate }}</h4>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="youtube"
                      value="{{ youtube }}"
                      [readonly]="!edit4"
                    />
                  </div>
                </div>
              </div> -->
              <!--                            <div class="row mt-2">-->
              <!--                                <div class="col-12 col-sm-12 col-md-12 col-lg-4">-->
              <!--                                    <h4 class="title-2 mt-2">Pinterest</h4>-->
              <!--                                </div>-->
              <!--                                <div class="col-12 col-sm-12 col-md-12 col-lg-8">-->
              <!--                                    <div class="form-group">-->
              <!--                                        <input type="text" class="form-control" formControlName="pinterest" value="{{pinterest}}" [readonly]="!edit4">-->
              <!--                                    </div>-->
              <!--                                </div>-->
              <!--                            </div>-->
              <!--                            <div class="row mt-2">-->
              <!--                              <div class="col-12 col-sm-12 col-md-12 col-lg-4">-->
              <!--                                <h4 class="title-2 mt-2">WeChat</h4>-->
              <!--                              </div>-->
              <!--                              <div class="col-12 col-sm-12 col-md-12 col-lg-8">-->
              <!--                                <div class="form-group">-->
              <!--                                  <input type="text" class="form-control" formControlName="wechat" value="{{wechat}}" [readonly]="!edit4">-->
              <!--                                </div>-->
              <!--                              </div>-->
              <!--                            </div>-->
              <!-- <div class="row mt-2">
                <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                  <h4 class="title-2 mt-2">{{ "TikTok" | translate }}</h4>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="tiktok"
                      value="{{ tiktok }}"
                      [readonly]="!edit4"
                    />
                  </div>
                </div>
              </div> -->
              <div class="d-flex justify-content-end pt-1">
                <button type="button" class="btn btn-outline-primary btn-sm mr-2 d-inline-flex align-items-center"
                  *ngIf="!edit5" (click)="editForm(5)" [disabled]="showloader2 === true">
                  <i class="fi fi-rr-edit mr-1"></i>
                  <span>{{ "Edit" | translate }}</span>
                </button>
                <button type="button" class="btn btn-light btn-sm mr-2 d-inline-flex align-items-center" *ngIf="edit5"
                  (click)="editForm(5, false)">
                  <span>{{ "Cancel" | translate }}</span>
                </button>
                <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center"
                  (click)="updateSocialMedia(5); editForm(5, false)" [disabled]="!edit5">
                  <i class="fi fi-rr-check mr-1"></i>
                  <span>{{ "Save" | translate }}</span>
                </button>
              </div>
              <div class="loader" *ngIf="showloader2">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Hicomm: one script for the <head> of every storefront page, the
           checkout form included. Stored as the hicomm_script store config. -->
      <div *ngIf="selectedTab == 'Hicomm'" class="row">
        <div class="col-12">
          <div class="card" [ngClass]="{ 'is-loading': hicommIsLoading }">
            <h4 class="title">{{ "Hicomm" | translate }}</h4>
            <p class="subtitle">
              {{
              "Paste your Hicomm JavaScript here. It is added to the header of every page of your store, including the
              checkout form."
              | translate
              }}
            </p>
            <div class="w-full mt-3">
              <label class="title-2 mb-2 d-block">{{ "Hicomm script" | translate }}</label>
              <div #hicommScriptRef class="editor-element"></div>
              <div class="d-flex justify-content-end mt-3">
                <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center"
                  (click)="saveHicommScript()" [disabled]="hicommIsLoading || !hicommIsChanged">
                  <i class="fi fi-rr-check mr-1" *ngIf="!hicommIsLoading"></i>
                  <span>{{ "Save" | translate }}</span>
                </button>
              </div>
            </div>
            <div class="loader" *ngIf="hicommIsLoading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="selectedTab == 'Customer Experience'">
        <form [formGroup]="messengerForm" method="post">
          <div class="card" [ngClass]="{ 'is-loading': showloader3 }">
            <h4 class="title">{{ "Messenger" | translate }}</h4>
            <p class="subtitle">
              {{
              "Get to know your customers better by providing the best assistance & answering their queries via various
              communication platforms. Enable your preferred communication platform(s) right away and let the fun chat
              begin!"
              | translate
              }}
            </p>
            <div class="row mt-2">
              <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                <h4 class="title-2 mt-2">{{ "Whatsapp" | translate }}</h4>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                <div class="form-group">
                  <input type="number" class="form-control" formControlName="whatsapp_number" placeholder="{{
                      'Enter your Whatsapp number here.' | translate
                    }}" value="{{ whatsapp_number }}" [readonly]="!edit6" (keypress)="numericOnly($event)" />
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                <h4 class="title-2 mt-2">{{ "Line Messenger" }}</h4>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                <div class="form-group">
                  <input type="text" class="form-control" formControlName="line_messenger" placeholder="{{
                      'Copy and Paste your Line link here.' | translate
                    }}" value="{{ line_messenger }}" [readonly]="!edit6"
                    [ngClass]="{ 'form-control-error': errorStatus }" />
                  <span *ngIf="errorStatus" style="color: #eb5757">{{
                    "Please enter the correct link" | translate
                    }}</span>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end pt-1">
              <button type="button" class="btn btn-outline-primary btn-sm d-inline-flex align-items-center mr-2"
                *ngIf="!edit6" (click)="editForm(6)" [disabled]="showloader3 === true">
                <i class="fi fi-rr-edit mr-1"></i>
                <span>{{ "Edit" | translate }}</span>
              </button>
              <button type="button" class="btn btn-light btn-sm mr-2 d-inline-flex align-items-center" *ngIf="edit6"
                (click)="editForm(6, false)">
                <span>{{ "Cancel" | translate }}</span>
              </button>
              <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center mr-2"
                [disabled]="!edit6" (click)="updateMessenger(6)">
                <i class="fi fi-rr-check mr-1"></i>
                <span>{{ "Save" | translate }}</span>
              </button>
            </div>
            <div class="loader" *ngIf="showloader3">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </form>
        <br>
        <form [formGroup]="checkoutPage" method="post">
          <div class="card" [ngClass]="{ 'is-loading': showloader3 }">
            <h4 class="title">{{ "Post-Checkout Contact Information" | translate }}</h4>
            <p class="subtitle">
              {{
              "Add your contact details below so customers can easily contact you after checkout."
              | translate
              }}
            </p>
            <div class="row mt-2">
              <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                <h4 class="title-2 mt-2">{{ "Whatsapp" | translate }}</h4>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                <div class="form-group">
                  <div class="input-group">
                    <input type="number" class="form-control" formControlName="whatsapp_number_thank_you_page"
                      placeholder="{{
                        'Enter your WhatsApp number (e.g., 6012 345 6789)' | translate
                      }}" value="{{ whatsapp_number_thank_you_page }}" [readonly]="!edit7"
                      (keypress)="numericOnly($event)" />
                    <div *ngIf="whatsapp_number_thank_you_page" class="input-group-append">
                      <button type="button" class="btn btn-outline-secondary" (click)="clearCheckoutWhatsapp()">
                        &times;
                      </button>
                    </div>
                  </div>
                </div>
                <p class="subtitle" style="font-size: 0.75rem;">{{ "Please enter your phone number, including the
                  country code (e.g., 60XXXXXXXX)." | translate }}</p>
              </div>
            </div>
            <div class="d-flex justify-content-end pt-1">
              <button type="button" class="btn btn-outline-primary btn-sm d-inline-flex align-items-center mr-2"
                *ngIf="!edit7" (click)="editForm(7)" [disabled]="showloader3 === true">
                <i class="fi fi-rr-edit mr-1"></i>
                <span>{{ "Edit" | translate }}</span>
              </button>
              <button type="button" class="btn btn-light btn-sm mr-2 d-inline-flex align-items-center" *ngIf="edit7"
                (click)="editForm(7, false)">
                <span>{{ "Cancel" | translate }}</span>
              </button>
              <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center" [disabled]="!edit7"
                (click)="updateCheckoutContact()">
                <i class="fi fi-rr-check mr-1"></i>
                <span>{{ "Save" | translate }}</span>
              </button>
            </div>
            <div class="loader" *ngIf="showloader3">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </form>
      </div>
      <!-- customer experience -->
      <!-- appearance checkout -->
      <div *ngIf="selectedTab == 'Checkout Steps'" class="row">
        <!-- Checkout theme. Hidden for Taiwan stores, whose single-page flow
             only supports the classic layout. -->
        <div class="col-12" *ngIf="showCheckoutThemeCard">
          <div class="card mt-25" [ngClass]="{ 'is-loading': isCheckoutThemeLoading }">
            <div class="loader" *ngIf="isCheckoutThemeLoading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <h4 class="title">{{ "Checkout Theme" | translate }}</h4>
            <p class="subtitle">
              {{
              "Choose how your checkout page is laid out. This applies to your checkout, express checkout and short-link
              pages."
              | translate
              }}
            </p>

            <div class="checkout-theme-options mt-3">
              <label class="checkout-theme-option" *ngFor="let option of checkoutThemeOptions"
                [class.active]="checkoutTheme === option.value">
                <span class="checkout-theme-option__head">
                  <input type="radio" name="checkout_theme" [value]="option.value" [(ngModel)]="checkoutTheme" />
                  <span class="checkout-theme-option__title">
                    {{ option.title | translate }}
                    <span class="checkout-theme-option__badge" *ngIf="checkoutThemeSaved === option.value">{{ "Current"
                      | translate }}</span>
                  </span>
                </span>
                <span class="checkout-theme-option__preview">
                  <img [src]="option.preview" [alt]="option.title | translate"
                    onerror="this.style.visibility='hidden'" />
                </span>
                <span class="checkout-theme-option__desc">
                  {{ option.description | translate }}
                </span>
              </label>
            </div>

            <div class="d-flex justify-content-end mt-3">
              <button class="btn btn-primary btn-sm" (click)="saveCheckoutTheme()" [disabled]="!isCheckoutThemeChanged">
                {{ "Save" | translate }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card mt-25" [ngClass]="{ 'is-loading': isCheckoutStepsLoading }">
            <div class="loader" *ngIf="isCheckoutStepsLoading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <h4 class="title">{{ "Checkout Steps" | translate }}</h4>
            <p class="subtitle">
              {{
              "For a streamlined checkout experience. Choose between single or multi-step for efficient, hassle-free
              transactions."
              | translate
              }}
            </p>
            <h4 class="subtitle mt-4 font-weight-bold">
              {{ "Steps Process" | translate }} :
            </h4>
            <div class="row mt-2">
              <div class="col-12 col-sm-12 col-md-12 col-lg-7">
                <div>
                  <label>
                    <div>
                      <input type="radio" name="checkout_steps" [value]="1" [(ngModel)]="isCheckoutStepsSingle"
                        (change)="onCheckoutStepChanged()"
                        class="no-webkit-appearance mr-2 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <span>{{ "Single" | translate }}</span>
                    </div>
                  </label>
                </div>
                <div>
                  <label>
                    <div>
                      <input type="radio" name="checkout_steps" [value]="0" [(ngModel)]="isCheckoutStepsSingle"
                        (change)="onCheckoutStepChanged()"
                        class="no-webkit-appearance mr-2 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                      <span>{{ "Multi-step" | translate }}</span>
                      <span class="text-gray font-italic" *ngIf="defaultCountry?.toLowerCase() === 'taiwan'">({{ "Email
                        Required" | translate }})</span>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-3">
              <button class="btn btn-primary btn-sm" (click)="changeCheckoutSteps()"
                [disabled]="!isCheckoutStepsChanged">
                {{ "Save" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="selectedTab == 'Checkout Testimonial'" class="row">
        <div class="col-12">
          <div class="card mt-25" [ngClass]="{ 'is-loading': isCheckoutStepsLoading }">
            <div class="loader" *ngIf="isCheckoutStepsLoading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <h4 class="title">{{ "Testimonial" | translate }}</h4>
            <p class="subtitle">
              {{
              "Toggle this button to display customer testimonials."
              | translate
              }}
            </p>
            <div class="row mt-2">
              <div class="col-12 col-sm-12 col-md-12 col-lg-7">
                <div class="align-middle section-switch">
                  <label class="switch">
                    <input type="checkbox" [checked]="testimonialToggle" (click)="toggleTestimonial($event)" />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
    <!-- menu card -->
  </div>
  <!-- new menu layout -->
</div>
<!-- Country badge for pixel rows: flag image, falling back to the bare
     country code when the flag asset is missing; Global keeps a text label. -->
<ng-template #pixelCountryBadge let-code>
  <span class="pixel-country-badge" [title]="pixelCountryLabel(code)">
    <ng-container *ngIf="code === 'GLOBAL'; else pixelFlagBadge">
      <i class="fi fi-rr-globe mr-1"></i>{{ "Global" | translate }}
    </ng-container>
    <ng-template #pixelFlagBadge>
      <img *ngIf="!pixelFlagFailed[code]" class="pixel-flag" [src]="getFlagImageURL(code)"
        (error)="onPixelFlagError(code)" [alt]="pixelCountryLabel(code)" />
      <ng-container *ngIf="pixelFlagFailed[code]">{{ code }}</ng-container>
    </ng-template>
  </span>
</ng-template>
<ng-template #pixelDialog let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="pixel-dialog-title">
      {{ (pixelEditIndex === null ? "Add Pixel ID" : "Edit Pixel ID") | translate }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cross')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pixel-dialog-body">
    <!-- Step indicator. Editing skips straight to the last step, so it is
         hidden then. -->
    <div class="pixel-steps">
      <span class="pixel-step" [class.active]="pixelStep === 1" [class.done]="pixelStep > 1">
        <span class="pixel-step-num">1</span>
        {{ "Setup" | translate }}
      </span>
      <span class="pixel-step-line"></span>
      <span class="pixel-step" [class.active]="pixelStep === 2" [class.done]="pixelStep > 2">
        <span class="pixel-step-num">2</span>
        {{ "Pixel" | translate }}
      </span>
      <span class="pixel-step-line"></span>
      <span class="pixel-step" [class.active]="pixelStep === 3">
        <span class="pixel-step-num">3</span>
        {{ "Where it runs" | translate }}
      </span>
    </div>

    <!-- ============ STEP 1: browser-only pixel, or pixel + CAPI =========== -->
    <div *ngIf="pixelStep === 1">
      <p class="pixel-dialog-hint">
        {{ "How do you want to track conversions for this pixel?" | translate }}
      </p>

      <div class="setup-kind-options" role="radiogroup">
        <button type="button" class="setup-kind-option" role="radio" [class.selected]="pixelSetupKind === 'capi'"
          [attr.aria-checked]="pixelSetupKind === 'capi'" (click)="choosePixelSetupKind('capi')">
          <span class="setup-kind-icon"><i class="fi fi-rr-cloud-upload"></i></span>
          <span class="setup-kind-text">
            <span class="setup-kind-name">
              {{ "Pixel ID + Conversions API" | translate }}
              <span class="setup-kind-tag">{{ "Recommended" | translate }}</span>
            </span>
            <span class="setup-kind-desc">
              {{ "Purchases are also sent from our server, so sales are still counted when the browser event is
              blocked." | translate }}
            </span>
          </span>
        </button>
        <button type="button" class="setup-kind-option" role="radio" [class.selected]="pixelSetupKind === 'pixel'"
          [attr.aria-checked]="pixelSetupKind === 'pixel'" (click)="choosePixelSetupKind('pixel')">
          <span class="setup-kind-icon"><i class="fi fi-rr-browser"></i></span>
          <span class="setup-kind-text">
            <span class="setup-kind-name">{{ "Pixel ID only" | translate }}</span>
            <span class="setup-kind-desc">
              {{ "The pixel fires in the visitor's browser. Quickest to set up - just a Pixel ID." | translate }}
            </span>
          </span>
        </button>

      </div>

      <!-- The (i) explainer, available before they have to choose. -->
      <button type="button" class="btn btn-link p-0 capi-explain-link" (click)="openCapiInfoDialog(capiInfoDialog)">
        <i class="fi fi-rr-info mr-1"></i>
        {{ "What is the Conversions API?" | translate }}
      </button>
    </div>

    <!-- ============ STEP 2a: plain Pixel ID ============================== -->
    <div *ngIf="pixelStep === 2 && pixelSetupKind === 'pixel'">
      <p class="pixel-dialog-hint">
        {{ "Find this in Meta Events Manager, under your pixel's details." | translate }}
      </p>
      <div class="form-group mb-0">
        <label class="tracking-field-label" for="pixel-id-input">
          {{ "Facebook Pixel ID" | translate }}
        </label>
        <input id="pixel-id-input" type="text" class="form-control tracking-input" placeholder="123456789012345"
          maxlength="20" [(ngModel)]="newPixelId" [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="pixelDialogError = ''" (keypress)="numericOnly($event)" />
      </div>
    </div>

    <!-- ============ STEP 2b: CAPI, via Facebook or manually ============== -->
    <div *ngIf="pixelStep === 2 && pixelSetupKind === 'capi'">
      <!-- Only one CAPI path is open while capiConnectEnabled is false, so the
           tabs would be a bar with a single tab on it. -->
      <div class="pixel-mode-tabs" role="tablist" *ngIf="capiConnectEnabled">
        <button type="button" class="pixel-mode-tab" role="tab" [class.selected]="pixelEntryMode === 'connect'"
          [attr.aria-selected]="pixelEntryMode === 'connect'" (click)="setPixelEntryMode('connect')">
          <i class="fi fi-brands-facebook"></i>
          {{ "Select from Facebook" | translate }}
        </button>
        <button type="button" class="pixel-mode-tab" role="tab" [class.selected]="pixelEntryMode === 'manual'"
          [attr.aria-selected]="pixelEntryMode === 'manual'" (click)="setPixelEntryMode('manual')">
          <i class="fi fi-rr-keyboard"></i>
          {{ "Manual" | translate }}
        </button>
      </div>

      <!-- --- Tab 1: pick from the connected Facebook account --- -->
      <div *ngIf="capiConnectEnabled && pixelEntryMode === 'connect'">
        <div class="pixel-loading" *ngIf="nexusLoading">
          <i class="fa fa-spinner fa-spin mr-2"></i>
          {{ "Loading your pixels..." | translate }}
        </div>

        <!-- Not connected / expired / missing permission. Never a dead end:
             they can reconnect, or switch to the Manual tab. -->
        <div class="pixel-connect-empty" *ngIf="!nexusLoading && nexusError">
          <p class="pixel-connect-msg">{{ nexusError }}</p>
          <div class="pixel-connect-actions">
            <a *ngIf="nexusSsoLink" class="btn btn-primary btn-sm" [href]="nexusSsoLink" target="_blank" rel="noopener">
              <i class="fi fi-brands-facebook mr-1"></i>
              {{ "Connect Facebook" | translate }}
            </a>
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="setPixelEntryMode('manual')">
              {{ "Enter manually" | translate }}
            </button>
          </div>
        </div>

        <div *ngIf="!nexusLoading && !nexusError">
          <p class="pixel-dialog-hint">
            {{ "Purchases will be sent from our server using this Facebook account, so there is no token to paste." |
            translate }}
          </p>

          <div class="pixel-empty-note" *ngIf="!nexusPixels.length && !showCreatePixel">
            {{ "No pixels found on your Facebook account." | translate }}
          </div>

          <!-- The pixel they want may belong to a different Facebook account.
               Offered whether or not this one has pixels: a dealer is not
               bound to the first account they connected, and this list only
               shows what that account can see. -->
          <div class="nexus-switch-account" *ngIf="nexusSsoLink">
            <span class="nexus-switch-text">
              {{ "Don't see the pixel you're looking for?" | translate }}
            </span>
            <a class="btn btn-link p-0 nexus-switch-link" [href]="nexusSsoLink" target="_blank" rel="noopener">
              <i class="fi fi-brands-facebook mr-1"></i>
              {{ "Connect another Facebook account" | translate }}
            </a>
          </div>

          <div class="nexus-pixel-list" *ngIf="nexusPixels.length">
            <button type="button" class="nexus-pixel-option" *ngFor="let p of nexusPixels"
              [class.selected]="newPixelId === p.pixel_id" [attr.aria-pressed]="newPixelId === p.pixel_id"
              (click)="chooseNexusPixel(p.pixel_id)">
              <span class="nexus-pixel-name">{{ p.name || ("Untitled pixel" | translate) }}</span>
              <span class="nexus-pixel-meta">
                <code>{{ p.pixel_id }}</code>
                <span *ngIf="p.account_name" class="nexus-pixel-account">{{ p.account_name }}</span>
              </span>
            </button>
          </div>

          <!-- Create a new pixel on one of their ad accounts. -->
          <div class="nexus-create-block" *ngIf="nexusAdAccounts.length">
            <button type="button" class="btn btn-link p-0 nexus-create-toggle" *ngIf="!showCreatePixel"
              (click)="showCreatePixel = true">
              <i class="fi fi-rr-plus mr-1"></i>
              {{ "Create a new pixel" | translate }}
            </button>

            <div class="nexus-create-form" *ngIf="showCreatePixel">
              <label class="tracking-field-label">{{ "New pixel name" | translate }}</label>
              <input type="text" class="form-control tracking-input mb-2"
                [placeholder]="'e.g. My Store Pixel' | translate" maxlength="80" [(ngModel)]="newPixelName"
                [ngModelOptions]="{ standalone: true }" />
              <label class="tracking-field-label">{{ "Ad account" | translate }}</label>
              <select class="form-control tracking-input mb-2" [(ngModel)]="newPixelAccountId"
                [ngModelOptions]="{ standalone: true }">
                <option *ngFor="let a of nexusAdAccounts" [value]="a.account_id">
                  {{ a.name || a.account_id }}
                </option>
              </select>
              <div class="nexus-create-actions">
                <button type="button" class="btn btn-primary btn-sm" [disabled]="creatingPixel"
                  (click)="createNexusPixel()">
                  <i class="fa fa-spinner fa-spin mr-1" *ngIf="creatingPixel"></i>
                  {{ "Create pixel" | translate }}
                </button>
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="creatingPixel"
                  (click)="showCreatePixel = false">
                  {{ "Cancel" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- --- Tab 2: pixel id and token by hand --- -->
      <div *ngIf="pixelEntryMode === 'manual'">
        <!-- With the tabs hidden this is the whole of step 2, so it says what
             the step is for the way the browser-only step does. -->
        <p class="pixel-dialog-hint" *ngIf="!capiConnectEnabled">
          {{ "Both values come from Meta Events Manager, under your pixel's details." | translate }}
        </p>

        <!-- This pixel sends through a connected Facebook account, and that
             path is currently closed. Saying so beats silently dropping it to
             browser-only the moment they save a country change. -->
        <small class="capi-token-warn" *ngIf="!capiConnectEnabled && newPixelWasAccountSourced">
          {{ "This pixel sends purchases using a connected Facebook account. That option is unavailable for now: paste
          an access token to keep sending from our server, or save without one and the pixel will fire in the browser
          only." | translate }}
        </small>

        <div class="form-group mb-2">
          <label class="tracking-field-label">{{ "Facebook Pixel ID" | translate }}</label>
          <input type="text" class="form-control tracking-input" placeholder="123456789012345" maxlength="20"
            [(ngModel)]="newPixelId" [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onManualPixelFieldChange()" (keypress)="numericOnly($event)" />
        </div>

        <div class="form-group mb-0">
          <label class="tracking-field-label" for="pixel-capi-token">
            {{ "Conversions API Access Token" | translate }}
          </label>
          <p class="capi-source-help">
            {{ "Generate this in Meta Events Manager: open your pixel, go to Settings, then Generate access token." |
            translate }}
          </p>
          <textarea id="pixel-capi-token" class="form-control capi-token-input" rows="3" spellcheck="false"
            autocomplete="off"
            [placeholder]="(revealingToken ? 'Loading saved token...' : (newPixelHadToken && !newPixelCapiToken ? 'Leave empty to keep the saved token' : 'Paste the access token')) | translate"
            [(ngModel)]="newPixelCapiToken" [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onManualPixelFieldChange()"></textarea>

          <!-- Verdict on the pixel id + token pair, checked against Meta once
               both fields are filled. -->
          <div class="token-check token-check-invalid" *ngIf="tokenCheckState === 'invalid'">
            <i class="fi fi-rr-cross-circle mr-1"></i>
            {{ tokenCheckError || ("This access token is not valid for this Pixel ID." | translate) }}
          </div>

          <!-- Reveal button / status for saved token -->
          <div class="capi-token-reveal" *ngIf="pixelEditIndex !== null && newPixelHadToken && !newPixelCapiToken">
            <small class="capi-token-note">
              {{ (revealingToken ? "Loading saved token..." : "A token is already saved for this pixel.") | translate }}
            </small>
            <button type="button" class="btn btn-link p-0 capi-token-reveal-btn" [disabled]="revealingToken"
              (click)="revealPixelCapiToken()">
              <i class="fa fa-spinner fa-spin mr-1" *ngIf="revealingToken"></i>
              <i class="fi fi-rr-eye mr-1" *ngIf="!revealingToken"></i>
              {{ (revealingToken ? "Loading..." : "Show saved token") | translate }}
            </button>
          </div>

          <small class="capi-token-note" *ngIf="newPixelHadToken && pixelEditIndex === null">
            {{ "A token is already saved for this pixel. For your security it is not shown." | translate }}
          </small>
          <small class="capi-token-note" *ngIf="!newPixelHadToken && tokenCheckState !== 'invalid'">
            {{ "Leave this empty and the pixel will only fire in the browser." | translate }}
          </small>
        </div>
      </div>
    </div>

    <!-- ============ STEP 3: which storefronts it runs on ================== -->
    <div *ngIf="pixelStep === 3">

      <!-- What steps 1 and 2 settled, so the last step is not a decision made
           blind. Read-only on both flows now: the id is edited on step 2. -->
      <div class="pixel-section" *ngIf="newPixelId">
        <label class="tracking-field-label">{{ "Pixel ID" | translate }}</label>
        <div class="pixel-chosen-summary">
          <code class="pixel-id">{{ newPixelId }}</code>
          <span class="capi-badge" *ngIf="newPixelCapiSource !== 'none'">
            <i class="fi fi-rr-cloud-upload mr-1"></i>
            {{ "CAPI" | translate }}
          </span>
          <span class="pixel-chosen-note" *ngIf="newPixelCapiSource === 'none'">
            {{ "Browser only" | translate }}
          </span>
        </div>

        <!-- The stored token is write-only -- it never reaches the browser --
             so it cannot be carried across to a different id. -->
        <small class="capi-token-warn" *ngIf="editRenamesPixelWithToken">
          <i class="fi fi-rr-exclamation mr-1"></i>
          {{ "The access token saved under the old Pixel ID will be removed when you save." | translate }}
        </small>
      </div>

      <div class="pixel-section">
        <label class="tracking-field-label">{{ "Country" | translate }}</label>
        <!-- Sits with the tiles it explains. It used to open the dialog, where
             it described a section the reader had not reached yet. -->
        <p class="pixel-dialog-hint">
          {{ "Global pixels load on every storefront. Country pixels load only on that country's storefront." |
          translate }}
        </p>
        <div class="pixel-country-tiles" role="group">
          <button type="button" class="pixel-country-tile" [class.selected]="isNewPixelCountrySelected('GLOBAL')"
            [attr.aria-pressed]="isNewPixelCountrySelected('GLOBAL')" (click)="toggleNewPixelCountry('GLOBAL')">
            <i class="fi fi-rr-globe mr-1"></i>
            {{ "Global" | translate }}
          </button>
          <button type="button" class="pixel-country-tile" *ngFor="let country of pixelCountryList"
            [class.selected]="isNewPixelCountrySelected(country.country_code)"
            [attr.aria-pressed]="isNewPixelCountrySelected(country.country_code)"
            (click)="toggleNewPixelCountry(country.country_code)">
            <img *ngIf="!pixelFlagFailed[country.country_code]" class="pixel-flag mr-1"
              [src]="getFlagImageURL(country.country_code)" (error)="onPixelFlagError(country.country_code)" alt="" />
            {{ pixelCountryLabel(country.country_code) }}
          </button>
        </div>
      </div>
    </div>

    <div class="pixel-dialog-error text-danger mt-2" *ngIf="pixelDialogError">
      {{ pixelDialogError }}
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-between align-items-center">
    <div>
      <button type="button" class="btn btn-light btn-sm d-inline-flex align-items-center"
        (click)="modal.dismiss('cancel')">
        <span>{{ "Cancel" | translate }}</span>
      </button>
    </div>
    <div class="d-inline-flex align-items-center" style="gap: 8px;">
      <button type="button" class="btn btn-light btn-sm d-inline-flex align-items-center" *ngIf="pixelStep > 1"
        (click)="backPixelStep()">
        <i class="fi fi-rr-angle-left mr-1"></i>
        <span>{{ "Back" | translate }}</span>
      </button>
      <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center" *ngIf="pixelStep < 3"
        [disabled]="
          (pixelStep === 1 && pixelSetupKind === null) ||
          (pixelStep === 2 && tokenCheckState === 'checking')
        " (click)="nextPixelStep()">
        <i class="fa fa-spinner fa-spin mr-1" *ngIf="tokenCheckState === 'checking'"></i>
        <span>{{ (tokenCheckState === 'checking' ? "Checking this token..." : "Next") | translate }}</span>
        <i class="fi fi-rr-angle-right ml-1" *ngIf="tokenCheckState !== 'checking'"></i>
      </button>
      <button type="button" class="btn btn-primary btn-sm d-inline-flex align-items-center" *ngIf="pixelStep === 3"
        [disabled]="pixelSaving" (click)="savePixelForm(modal)">
        <i class="fa fa-spinner fa-spin mr-1" *ngIf="pixelSaving"></i>
        <i class="fi fi-rr-check mr-1" *ngIf="!pixelSaving"></i>
        <span>{{ "Save" | translate }}</span>
      </button>
    </div>
  </div>
</ng-template>

<!-- Explains what the Conversions API does and when to use it. Opened from
     the "How does this work?" link in the pixel dialog. -->
<ng-template #capiInfoDialog let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="capi-info-title">
      {{ "About the Conversions API" | translate }}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cross')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body capi-info-body">
    <p>
      {{ "Your Facebook Pixel runs in the visitor's browser. When someone completes a purchase, the browser tells Meta
      about it. That is how conversions are normally tracked." | translate }}
    </p>
    <p>
      {{ "The problem is that browser events often do not arrive. Ad blockers, tracking protection in browsers like
      Safari and Firefox, and people leaving the page too quickly all stop the event from reaching Meta. Those sales
      still happen, but Meta never counts them." | translate }}
    </p>
    <p>
      {{ "The Conversions API fixes this by also sending the purchase from our server, which nothing in the browser can
      block. Meta matches the two reports and counts the sale once, so you get more accurate numbers without any double
      counting." | translate }}
    </p>

    <h6 class="capi-info-subtitle">{{ "What happens for this pixel" | translate }}</h6>
    <ul class="capi-info-list">
      <li>
        <strong>{{ "Browser only" | translate }}</strong>
        {{ "- the pixel fires in the browser only. Nothing is sent from our server, so blocked events are lost. This is
        how pixels worked before this option existed." | translate }}
      </li>
      <!-- Both bullets describe paths the dialog actually offers; the account
           one is not one of them while capiConnectEnabled is false. -->
      <li *ngIf="capiConnectEnabled">
        <strong>{{ "Connected Facebook account" | translate }}</strong>
        {{ "- we use the access token from the Facebook account you connected to your dashboard. Nothing to paste, but
        it stops working if that connection expires or is removed." | translate }}
      </li>
      <li>
        <strong>{{ "Enter an access token" | translate }}</strong>
        {{ "- you paste a token generated in Meta Events Manager for this pixel." | translate }}
        <span *ngIf="capiConnectEnabled">
          {{ "Use this when the pixel belongs to a different Meta account than the one you connected, or when you have
          not connected one." | translate }}
        </span>
      </li>
    </ul>

    <h6 class="capi-info-subtitle">{{ "Where to get an access token" | translate }}</h6>
    <p>
      {{ "In Meta Events Manager, open your pixel, go to Settings, and use Generate access token under the Conversions
      API section. Copy the token and paste it here." | translate }}
    </p>
    <p class="capi-info-note">
      {{ "Your token is stored securely and is never shown on your storefront or sent to visitors." | translate }}
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn-sm" (click)="modal.close('ok')">
      {{ "Got it" | translate }}
    </button>
  </div>
</ng-template>
<ng-template #success let-modal>
  <div class="modal-body text-center">
    <div class="row" align="center">
      <div class="col pt-4 pt-lg-0">
        <h4>{{ this.errorMsg }}</h4>
      </div>
    </div>
    <button class="btn btn-primary" type="button" name="button" (click)="modal.close('Send click')">
      Close
    </button>
  </div>
</ng-template>